import { Typography } from "@mui/material";
import React from "react";

const CFormLabels = ({ label }) => {
  return <Typography >{label}</Typography>;
};
export default CFormLabels;
